import styled from "styled-components";

export const Color = styled.span`
    color: ${props => props.color ?? '#4480F7'};
`